import {Action} from '../../../../common/types/common';
import {AttachmentFileState, AttachmentsForm, DocumentTypes, FileState, VersionState} from '../types/types';
import {DocsState} from '../types/reducers';
import {AnyAction} from 'redux';

export const GET_LOAN_APPLICATION_ATTACHMENTS_MX_ACTION: Action = {
    name: 'GET_LOAN_APPLICATION_ATTACHMENTS_MX_ACTION',
    action: (token: string, showAttachmentSideBar: boolean = false, documentType: DocumentTypes, cleanReducer: boolean = true) => ({
        token,
        showAttachmentSideBar,
        documentType,
        cleanReducer,
        type: GET_LOAN_APPLICATION_ATTACHMENTS_MX_ACTION.name
    })
};

export const SELECT_FILES_ACTION = {
    name: 'SELECT_FILES_ACTION',
    action: (files: FileList, ownerName: string, error: string) => ({
        files,
        ownerName,
        error,
        type: SELECT_FILES_ACTION.name
    })
};

export const GOT_DOCUMENT_TYPES_ACTION: Action = {
    name: 'GOT_DOCUMENT_TYPES_ACTION',
    action: (documentTypes: DocumentTypes[]) => ({
        documentTypes,
        type: GOT_DOCUMENT_TYPES_ACTION.name
    })
};

export const CREATE_LOAN_ATTACHMENTS: Action = {
    name: 'CREATE_LOAN_ATTACHMENTS',
    action: (attachmentsForm: AttachmentsForm) => ({
        attachmentsForm,
        type: CREATE_LOAN_ATTACHMENTS.name
    })
};

export const ON_CHANGE_DOCUMENT_TYPE: Action = {
    name: 'ON_CHANGE_DOCUMENT_TYPE',
    action: (documentType: DocumentTypes, documentState: DocsState, error: string) => ({
        documentType, documentState, error,
        type: ON_CHANGE_DOCUMENT_TYPE.name
    })
};

export const ON_SELECT_FILTER: Action = {
    name: 'ON_SELECT_FILTER',
    action: filter => ({
        filter,
        type: ON_SELECT_FILTER.name
    })
};

export const CLEAN_SELECT_FILTER: Action = {
    name: 'CLEAN_SELECT_FILTER',
    action: () => ({
        type: CLEAN_SELECT_FILTER.name
    })
};

export const OPEN_UPLOAD_FILES_MODAL: Action = {
    name: 'OPEN_UPLOAD_FILES_MODAL',
    action: (formType: string) => ({
        formType,
        type: OPEN_UPLOAD_FILES_MODAL.name
    })
};

export const GOT_LOAN_APPLICATION_ATTACHMENTS = {
    name: 'GOT_LOAN_APPLICATION_ATTACHMENTS',
    action: (documents, documentState: DocsState, documentType: DocumentTypes) => ({
        documents,
        documentState,
        documentType,
        type: GOT_LOAN_APPLICATION_ATTACHMENTS.name
    })
};

export const DELETE_LOAN_ATTACHMENT_ACTION_REQUEST = {
    name: 'DELETE_LOAN_ATTACHMENT_ACTION_REQUEST',
    action: (file: FileState, documentType: DocumentTypes) => ({
        file,
        documentType,
        type: DELETE_LOAN_ATTACHMENT_ACTION_REQUEST.name
    })
};

export const DELETE_LOAN_ATTACHMENT_ACTION_SUCCESSFUL = {
    name: 'DELETE_LOAN_ATTACHMENT_ACTION_SUCCESSFUL',
    action: (file: FileState, documentType: DocumentTypes = null) => ({
        file,
        documentType,
        type: DELETE_LOAN_ATTACHMENT_ACTION_SUCCESSFUL.name
    })
};

export const DELETE_LOAN_ATTACHMENT_ACTION_FAILURE = {
    name: 'DELETE_LOAN_ATTACHMENT_ACTION_FAILURE',
    action: (file: FileState, error: string) => ({
        file,
        error,
        type: DELETE_LOAN_ATTACHMENT_ACTION_FAILURE.name
    })
};

export const UPLOAD_LOAN_ATTACHMENTS_ACTION_REQUEST = {
    name: 'UPLOAD_LOAN_ATTACHMENTS_ACTION_REQUEST',
    action: (files: FileState[], documentTypes: DocumentTypes, documentsVersionId: string, payloadAction?: any) => ({
        files,
        documentTypes,
        documentsVersionId,
        payloadAction,
        type: UPLOAD_LOAN_ATTACHMENTS_ACTION_REQUEST.name
    })
};

export const DOWNLOAD_FROM_URI_AND_UPLOAD_LOAN_ATTACHMENT_ACTION_REQUEST = {
    name: 'DOWNLOAD_FROM_URI_AND_UPLOAD_LOAN_ATTACHMENT_ACTION_REQUEST',
    action: (
        uri: string,
        authorName: string,
        fileName: string,
        documentType: DocumentTypes,
        loanApplication,
        successActionsFn: AnyAction[] = [],
    ) => ({
        uri,
        authorName,
        fileName,
        documentType,
        loanApplication,
        successActionsFn,
        type: DOWNLOAD_FROM_URI_AND_UPLOAD_LOAN_ATTACHMENT_ACTION_REQUEST.name,
    }),
};

export const UPLOAD_AND_DELETE_LOAN_ATTACHMENTS_ACTION_REQUEST = {
    name: 'UPLOAD_AND_DELETE_LOAN_ATTACHMENTS_ACTION_REQUEST',
    action: (file: FileState, filesQueue: FileState[], documentTypes: DocumentTypes, documentsVersionId: string) => ({
        file,
        filesQueue,
        documentTypes,
        documentsVersionId,
        type: UPLOAD_AND_DELETE_LOAN_ATTACHMENTS_ACTION_REQUEST.name
    })
};

export const UPLOAD_LOAN_ATTACHMENTS_SUCCESSFUL = {
    name: 'UPLOAD_LOAN_ATTACHMENTS_SUCCESSFUL',
    action: (versionId: string, fileId: string, file: FileState, documentType: DocumentTypes = null) => ({
        versionId,
        fileId,
        file,
        documentType,
        type: UPLOAD_LOAN_ATTACHMENTS_SUCCESSFUL.name
    })
};

export const UPLOAD_LOAN_ATTACHMENTS_FAILURE = {
    name: 'UPLOAD_LOAN_ATTACHMENTS_FAILURE',
    action: (file: FileState, error: string) => ({
        file,
        error,
        type: UPLOAD_LOAN_ATTACHMENTS_FAILURE.name
    })
};

export const CREATE_NEW_VERSION_ACTION = {
    name: 'CREATE_NEW_VERSION_ACTION',
    action: () => ({
        type: CREATE_NEW_VERSION_ACTION.name
    })
};

export const OPEN_SIDEBAR_ALL_ATTACHMENTS = {
    name: 'OPEN_SIDEBAR_ALL_ATTACHMENTS',
    action: (documentType: DocumentTypes, formType: string, documentState: DocsState) => ({
        documentType,
        formType,
        documentState,
        type: OPEN_SIDEBAR_ALL_ATTACHMENTS.name
    })
};

export const CLOSE_SIDEBAR_ALL_ATTACHMENTS = {
    name: 'CLOSE_SIDEBAR_ALL_ATTACHMENTS',
    action: () => ({
        type: CLOSE_SIDEBAR_ALL_ATTACHMENTS.name
    })
};

export const ON_PRESS_TOGGLE_TREE = {
    name: 'ON_PRESS_TOGGLE_TREE',
    action: (itemVersion: VersionState) => ({
        itemVersion,
        type: ON_PRESS_TOGGLE_TREE.name
    })
};

export const OPEN_SIDEBAR_DETAIL_ATTACHMENTS = {
    name: 'OPEN_SIDEBAR_DETAIL_ATTACHMENTS',
    action: (file: FileState, documentType: DocumentTypes, documentState: DocsState) => ({
        file,
        documentType,
        documentState,
        type: OPEN_SIDEBAR_DETAIL_ATTACHMENTS.name
    })
};

export const CLOSE_SIDEBAR_DETAIL_ATTACHMENTS = {
    name: 'CLOSE_SIDEBAR_DETAIL_ATTACHMENTS',
    action: () => ({
        type: CLOSE_SIDEBAR_DETAIL_ATTACHMENTS.name
    })
};

export const ON_PRESS_ARROW_ATTACHMENT_DETAIL = {
    name: 'ON_PRESS_ARROW_ATTACHMENT_DETAIL',
    action: (files: FileState[], file: FileState) => ({
        files, file,
        type: ON_PRESS_ARROW_ATTACHMENT_DETAIL.name
    })
};

export const SEND_LOAN_ATTACHMENTS_TO_TARGET_ACTION_REQUEST = {
    name: 'SEND_LOAN_ATTACHMENTS_TO_TARGET_ACTION_REQUEST',
    action: (documentType: DocumentTypes, file: AttachmentFileState, target: string) => ({
        documentType, file, target,
        type: SEND_LOAN_ATTACHMENTS_TO_TARGET_ACTION_REQUEST.name
    })
};

export const SEND_LOAN_ATTACHMENTS_TO_TARGET_ACTION_SUCCESSFUL = {
    name: 'SEND_LOAN_ATTACHMENTS_TO_TARGET_ACTION_SUCCESSFUL',
    action: (fileId: string) => ({
        fileId,
        type: SEND_LOAN_ATTACHMENTS_TO_TARGET_ACTION_SUCCESSFUL.name
    })
};
